import { getBoundRefProvider } from '@wix/materializer'

export const getSiteFeatureBoundRefProvider = (featureName: string) => getBoundRefProvider(['exports', featureName])

export const getPageFeatureBoundRefProvider = (featureName: string) => {
	const boundRefProvider = getBoundRefProvider(['exports', featureName])
	return <T>(innerPath: Array<string>) => ({ ...boundRefProvider<T>(innerPath), shouldLoadPageFeature: true })
}
